// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_08a71","select":"ef550"};